module.exports = __webpack_public_path__ + "img/recommend.f71c4571.png";